
// @ts-nocheck
import locale_en_45US_46json_e68ecede from "#nuxt-i18n/e68ecede";
import locale_fr_45FR_46json_c9bc0ffd from "#nuxt-i18n/c9bc0ffd";

export const localeCodes =  [
  "en",
  "fr"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_45US_46json_e68ecede",
      load: () => Promise.resolve(locale_en_45US_46json_e68ecede),
      cache: true
    }
  ],
  fr: [
    {
      key: "locale_fr_45FR_46json_c9bc0ffd",
      load: () => Promise.resolve(locale_fr_45FR_46json_c9bc0ffd),
      cache: true
    }
  ]
}

export const vueI18nConfigs = []

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/usr/src/nuxt-app/i18n/locales/en-US.json",
          cache: undefined
        }
      ]
    },
    {
      code: "fr",
      name: "Français",
      files: [
        {
          path: "/usr/src/nuxt-app/i18n/locales/fr-FR.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "fr",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/usr/src/nuxt-app/i18n/locales/en-US.json",
        cache: undefined
      }
    ]
  },
  {
    code: "fr",
    name: "Français",
    files: [
      {
        path: "/usr/src/nuxt-app/i18n/locales/fr-FR.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/